import Typography from '@mui/material/Typography';
import AuthLayout from './AuthLayout';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useResponsive, useResponsiveTypography } from '../utils/responsive';

const Welcome = () => {
   const navigate = useNavigate();
   const [searchParams] = useSearchParams();
   const { isMobile } = useResponsive();
   const { fontSize } = useResponsiveTypography();

   const handleLogin = () => {
      try {
         const returnUrl = searchParams.get('returnUrl') || '';

         if (returnUrl) {
            navigate(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
            return;
         } else {
            navigate('/login', { replace: true });
         }
      } catch (error) {}
   };

   return (
      <AuthLayout>
         <Typography 
            variant='h4' 
            color='primary' 
            sx={{ 
               mb: 2,
               fontSize: isMobile ? fontSize.h3 : fontSize.h1,
               textAlign: 'center',
               px: isMobile ? 2 : 0
            }}
         >
            Welcome to Wetrippen
         </Typography>
         <Typography 
            variant='body1' 
            color='text.secondary' 
            sx={{ 
               mb: 3,
               fontSize: isMobile ? fontSize.body2 : fontSize.body1,
               textAlign: 'center',
               px: isMobile ? 2 : 0
            }}
         >
            Please verify your email to continue
         </Typography>
         <Button 
            variant='contained' 
            color='primary' 
            onClick={handleLogin}
            size={isMobile ? 'large' : 'medium'}
            sx={{
               minHeight: isMobile ? '48px' : '40px',
               px: isMobile ? 4 : 3,
               fontSize: isMobile ? fontSize.body1 : 'inherit',
               width: isMobile ? '100%' : 'auto',
               maxWidth: isMobile ? '280px' : 'none'
            }}
         >
            Get Started
         </Button>
      </AuthLayout>
   );
};

export default Welcome;
